import { files, generalRef } from "@/fireinit.js";
import Vue from "vue";
import axios from "axios";

export default {
  loadAll: async ({ commit, rootState }) => {
    let contributionData = await axios.get(
      `${rootState.axios.API}general/settings`
    );
    commit("setContributions", contributionData.data.contributions);
  },
  save: async ({ commit, rootState }, formData) => {
    let contributionData = await axios.put(
      `${rootState.axios.API}general/settings`,
      formData,
      {
        headers: {
          Authorization: `Bearer ${rootState.user.data.auth._lat}`,
        },
      }
    );
  },
  changeType: ({ commit }, type) => {
    localStorage.setItem("type", type);
    commit("setType", type);
  },
};
